enum OwnersStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description list Owners
   */
  OwnersList = "/v2/owners/"
}

const OwnersDynamic = {
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description detail Owners
   */
  ownersDetail: (id: number) => `/v2/owners/${id}`,
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description update Owners
   */
  ownersUpdate: (id: number) => `/v2/owners/${id}?_method=PUT`,

  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description detail Owners
   */
  commonProperties: (owner_id: number, people_id: number) =>
    `/v2/owners/common-properties/${owner_id}/${people_id}`
};

export const OwnersEndpoints = {
  ...OwnersDynamic,
  ...OwnersStatic
};

export type OwnersEndpoints = typeof OwnersEndpoints;
